import { http } from './client'
import type { ProductMetrics } from '../types/api'

export async function getProductReport(
  scanId: string,
  forceRegenerate: boolean = false,
): Promise<ProductMetrics> {
  const qs = new URLSearchParams({
    force_regenerate: String(forceRegenerate),
  })
  return http.get(`/api/v1/scans/${scanId}/product-report?${qs}`)
}
